import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faQuoteLeft,
  faCheckCircle,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import {} from "@fortawesome/free-regular-svg-icons";
import {} from "@fortawesome/free-brands-svg-icons";
import "./TutorStories.css";
import $ from "jquery";
import HeaderSub from '../HeaderSub/HeaderSub';

export default () => {
  {
    $(".frequently-qstn .btn-link").click(function () {
      if ($(this).parent().hasClass("show-clr")) {
        $(this).parent().removeClass("show-clr");
      } else {
        $(".frequently-qstn .card-header").removeClass("show-clr");
        $(this).parent().addClass("show-clr");
      }
    });
  }
  return (
    <div className="container">
      <div className="tutor-setup-page float-left w-100">
        {/* header */}
        <HeaderSub/>
        {/* setup-top */}
        <div className="setup-top float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="setup-left float-left w-100">
                  <label>TUTOR</label>
                  <h2>How Christopher Tutors</h2>
                  <p>I tutor to be positiveinfluence on a student’s journey</p>
                </div>
                <div className="join-date">
                  <span>2014</span>
                  <label>Join Askademia</label>
                </div>
                <div className="join-date">
                  <span>205</span>
                  <label>Taught Sessions</label>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="setup-right float-left w-100">
                  <img src={require("../../assets/images/setup-top.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*tutor information*/}
        <div className="tutor-information-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-12">
                <div className="tutor-information-head float-left w-100">
                  <h2>Learn how Christoper tutors with Askademia</h2>
                </div>
              </div>
              <div className="col-12">
                <div className="tutor-information float-left w-100">
                  <h3>You Are In Control Of How You Tutor?</h3>
                  <p>
                    I think the key to exam preparation is many small bursts over
                    long periods of time. This essentially means studying from the
                    start of academic year, almost every day (5 days a week, say),
                    but only for a short amount of time e.g an hour or two.
                  </p>
                  <h3>Why did you decide to join Askademia?</h3>
                  <p>
                    I think the key to exam preparation is many small bursts over
                    long periods of time. This essentially means studying from the
                    start of academic year, almost every day (5 days a week, say),
                    but only for a short amount of time e.g an hour or two.
                  </p>
                  <h3>Taught levels and subjects</h3>
                  <div className="level-subject float-left w-100">
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="level float-left w-100">
                          <h4>Levels</h4>
                          <ul>
                            <li>Primary & Early Years</li>
                            <li>Key Stage 3</li>
                            <li>Degree</li>
                            <li>Professional</li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="subject float-left w-100">
                          <h4>Subjects</h4>
                          <ul>
                            <li>
                              <span>11 + Maths</span>
                              <span>11 + Maths</span>
                            </li>
                            <li>
                              <span>Maths</span>
                            </li>
                            <li>
                              <span>Statistics</span>
                              <span>Calculus</span>
                            </li>
                            <li>
                              <span>Cv Help</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h3>
                    What were your concerns before you joined started tutoring?
                  </h3>
                  <p>
                    While doing this you are constantly recapping the topics you
                    are struggling most to understand, and therefore utilising one
                    of the most efficient and effective study methods: spaced
                    repetition learning. The benefit of this method is that it
                    allows you to take the all important breaks from studying and
                    therefore enables you to enjoy a social life and hobbies.
                  </p>
                  <h3>
                    How do you prepare to make sure your tutees have a great
                    lesson with you?
                  </h3>
                  <p>
                    I think the key to exam preparation is many small bursts over
                    long periods of time. This essentially means studying from the
                    start of academic year, almost every day (5 days a week, say),
                    but only for a short amount of time e.g an hour or two.
                  </p>
                  <h3>Has tutoring change your lifestlye?</h3>
                  <p>
                    While doing this you are constantly recapping the topics you
                    are struggling most to understand, and therefore utilising one
                    of the most efficient and effective study methods: spaced
                    repetition learning. The benefit of this method is that it
                    allows you to take the all important breaks from studying and
                    therefore enables you to enjoy a social life and hobbies.
                  </p>
                  <h3>Describe preparation for a typical session? </h3>
                  <p>
                    I think the key to exam preparation is many small bursts over
                    long periods of time. This essentially means studying from the
                    start of academic year, almost every day (5 days a week, say),
                    but only for a short amount of time e.g an hour or two.
                  </p>
                  <h3>What’s your favourite thing about being a tutor? </h3>
                  <p>
                    While doing this you are constantly recapping the topics you
                    are struggling most to understand, and therefore utilising one
                    of the most efficient and effective study methods: spaced
                    repetition learning.
                  </p>
                  <h3>Whats your proudest moment as a tutor?</h3>
                  <p>
                    I think the key to exam preparation is many small bursts over
                    long periods of time. This essentially means studying from the
                    start of academic year, almost every day (5 days a week, say),
                    but only for a short amount of time e.g an hour or two.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* tutor-bottom */}
        <div className="container">
          <div className="tutor-bottom-m float-left w-100">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="tutor-bottom float-left w-100">
                    <div className="tutor-img float-left w-100">
                      <img
                        src={require("../../assets/images/tutor-Bimg.jpg")}
                        srcSet={`
                        ${require("../../assets/images/tutor-Bimg.jpg")} 450w, 
                        ${require("../../assets/images/tutor-Bimg.jpg")}
                    `}
                        alt="tutor-img"
                      />
                    </div>
                    <div className="tutor-content float-left w-100">
                      <p>
                        Hana tutors in London to share her love for biology Lorem
                      </p>
                      <a href="#">Learn More</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="tutor-bottom float-left w-100">
                    <div className="tutor-img float-left w-100">
                      <img
                        src={require("../../assets/images/tutor-Bimg2.jpg")}
                        srcSet={`
                        ${require("../../assets/images/tutor-Bimg2m.jpg")} 450w, 
                        ${require("../../assets/images/tutor-Bimg2.jpg")}
                    `}
                        alt="tutor-img"
                      />
                    </div>
                    <div className="tutor-content float-left w-100">
                      <p>
                        Hana tutors in London to share her love for biology Lorem
                      </p>
                      <a href="#">Learn More</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="tutor-bottom float-left w-100">
                    <div className="tutor-img float-left w-100">
                      <img
                        src={require("../../assets/images/tutor-Bimg3.jpg")}
                        srcSet={`
                        ${require("../../assets/images/tutor-Bimg3m.jpg")} 450w, 
                        ${require("../../assets/images/tutor-Bimg3.jpg")}
                    `}
                        alt="tutor-img"
                      />
                    </div>
                    <div className="tutor-content float-left w-100">
                      <p>
                        Hana tutors in London to share her love for biology Lorem
                      </p>
                      <a href="#">Learn More</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ready-to */}
        <div className="ready-to-m float-left w-100 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="ready-to float-left w-100">
                  <h3>Ready to tutoring?</h3>
                  <div className="start-btn float-left w-100">
                    <a href="#">Get Started</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="overlay"></div>
        </div>
      </div>
    </div>
  );
};
